import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { PageConfigService } from '../shared/services/page-config.service';
import { UiConfig } from '../shared/models/be.model';

// Centralizes the per-page config fetch that every routed page used to perform itself in
// ngOnInit. Routes without a configCode (e.g. dashboard) resolve to null — a config is not
// mandatory for every route, this only centralizes the fetch when one is declared.
export const pageConfigResolver: ResolveFn<UiConfig | null> = (route): Observable<UiConfig | null> => {
    const configCode: string | undefined = route.data['configCode'];
    if (!configCode) return of(null);

    const pageConfigService = inject(PageConfigService);
    // A failed fetch resolves to null instead of failing navigation, matching the previous
    // per-component behavior where an unhandled fetch error just left pageConfig unset.
    return pageConfigService.loadPageConfig(configCode).pipe(
        catchError(() => of(null)),
    );
};
